<snelstart-ui-dialog-definition id="tm" title="{{this.title}}" size="xl" [(visible)]="dialogVisible">
  <snelstart-ui-dialog-body>
    <form *ngIf="input"  [formGroup]="input">
      <div>
          <snelstart-ui-textarea-form-control formControlName="value"
                                              class="me-1 custom-input-800"
                                              [rows]="7"
          >
          </snelstart-ui-textarea-form-control>
      </div>
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x (click)="this.cancel()">Annuleren</snelstart-ui-button>
    <snelstart-ui-button id="save" type="primary" icon="check" (click)="this.submit()">
      Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

